
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8Jfqx", function(module, exports) {
/* eslint-disable */ /* tslint:disable */ /*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */ /**
 * @title Commerce Cloud Platform
 * @version 1.0.0
 * @baseUrl https://ccp-api-gateway.prod.atl-paas.net
 * @externalDocs https://developer.atlassian.com/platform/commerce-cloud-platform/security/authentication/
 * @contact CCP Developers (https://atlassian.slack.com/archives/C016U73MTC1)
 *
 * Commerce Cloud Platform (CCP) is a part of Project Tintin (go/tintin). Tintin is the foundational initiative unifying Pricing, Product Catalog, Subscriptions and Billing engines across all our Cloud products, to unleash Atlassian’s ability to scale to a $10B company.
 */ 
var $d5s5i = parcelRequire("d5s5i");

/**
 * The response from the client was not defined in the schema.
 * This doesn't necessarily mean that the fetch failed to perform its intended behaviour - It's just that the response
 * was not defined in the schema. You may want to wrap the fetch calls provided by this client with your own logic that
 * handles certain error codes as success regardless of whether it's defined in the schema or not.
 */ const $7f245dfb02e39f03$var$NOT_IN_SCHEMA = "not-in-schema";
/**
 * This error is reported when the schema does not list any mime types that we support in this client.
 */ const $7f245dfb02e39f03$var$MIME_TYPE_NOT_SUPPORTED = "mime-type-not-supported";
const $7f245dfb02e39f03$var$getValidResponseOrThrow = (result)=>{
    if (!(0, $d5s5i.isSuccess)(result)) {
        if (result.error) // eslint-disable-next-line no-console
        console.log(result.error);
        if (result.exception) // eslint-disable-next-line no-console
        console.error(result.exception);
        throw new Error(`getValidResponseOrThrow: request failed: ${String(result.error ?? result.exception)}`);
    }
    return result.payload;
};
const $7f245dfb02e39f03$export$390f7ebd9b7a4732 = (result)=>{
    const response = $7f245dfb02e39f03$var$getValidResponseOrThrow(result);
    if (response.status < 200 || response.status >= 300) {
        // eslint-disable-next-line no-console
        console.log(`getSuccessfulResultOrThrow: Response: ${response}`);
        throw new Error(`getSuccessfulResultOrThrow: Status code: ${response.status} ${response.response?.url ?? ""}`);
    }
    return response.body;
};
const $7f245dfb02e39f03$export$a7fcd798548c2cab = (endpoint)=>async (...args)=>$7f245dfb02e39f03$export$390f7ebd9b7a4732(await endpoint(...args));
const $7f245dfb02e39f03$export$231366cf7929fca = (handler)=>{
    return async (...args)=>{
        try {
            return await handler(...args);
        } catch (err) {
            // TODO: Remove once AFP supports TypeScript 4
            return (0, $d5s5i.exception)(err);
        }
    };
};
const $7f245dfb02e39f03$var$flatten = (params)=>{
    const result = {};
    Object.entries(params ?? {}).forEach(([key, value])=>{
        if (typeof value === "object") {
            Object.assign(result, $7f245dfb02e39f03$var$flatten(value));
            return;
        }
        result[key] = value;
    });
    return result;
};
const $7f245dfb02e39f03$var$FAKE_ORIGIN = "http://FAKE_ORIGIN";
/**
 * Determine if the given URL is a full URL (including the origin),
 * or if it it just a path
 */ const $7f245dfb02e39f03$var$isFullUrl = (url)=>new URL(url, $7f245dfb02e39f03$var$FAKE_ORIGIN).href === url;
const $7f245dfb02e39f03$export$a639a54e55b70225 = (endpointPath, baseGatewayUrl, queryParameters = {})=>{
    // The WHATWG URL API does not work with relative paths, hence FAKE_ORIGIN.
    // See: https://github.com/whatwg/url/issues/531
    const fakeUrl = new URL(endpointPath, $7f245dfb02e39f03$var$isFullUrl(baseGatewayUrl) ? baseGatewayUrl : $7f245dfb02e39f03$var$FAKE_ORIGIN);
    // TODO: find out how undefined, arrays, and objects should be encoded
    fakeUrl.search = new URLSearchParams($7f245dfb02e39f03$var$flatten(queryParameters)).toString();
    return $7f245dfb02e39f03$var$isFullUrl(baseGatewayUrl) ? fakeUrl.href : `${baseGatewayUrl}${fakeUrl.href.slice($7f245dfb02e39f03$var$FAKE_ORIGIN.length + 1)}`;
};
const $7f245dfb02e39f03$export$ac22a5efe63978d6 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/archive-configs/item-type/${pathParameters.itemType}/source-system/${pathParameters.sourceSystem}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/archive-configs/item-type/${itemType}/source-system/${sourceSystem}",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `archiveConfigsItemTypeSourceSystem_get_byItemTypeAndSourceSystem_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 409:
                case 413:
                case 500:
                case 509:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$511b1760d22f40bf = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/archives`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/archives",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `archives_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 404:
                case 409:
                case 413:
                case 500:
                case 509:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$5180125b642061b3 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/archives/item-type/${pathParameters.itemType}`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/archives/item-type/${itemType}",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `archivesItemType_get_byItemType_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 409:
                case 413:
                case 500:
                case 509:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$faaf08608a792b4f = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/archives/upload`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/archives/upload",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `archivesUpload_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 201:
                case 400:
                case 404:
                case 409:
                case 413:
                case 500:
                case 509:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$b39896a71d9902c0 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/audit-logs`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/audit-logs",
            method: "GET",
            operationId: "getAuditLogs",
            summary: null,
            methodName: `auditLogs_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$477c5184ae2b9d81 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/bill-to-party`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/bill-to-party",
            method: "GET",
            operationId: "get_1",
            summary: null,
            methodName: `billToParty_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 204:
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$a4f007423674219d = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/bill-to-party`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/bill-to-party",
            method: "PUT",
            operationId: "update",
            summary: null,
            methodName: `billToParty_put_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$9ef72d974677798 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/bill-to-party/price-eligibility`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/bill-to-party/price-eligibility",
            method: "GET",
            operationId: "getPriceEligibility_1",
            summary: null,
            methodName: `billToPartyPriceEligibility_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$1f2830ce31cd69f2 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/bill-to-party/price-eligibility`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/bill-to-party/price-eligibility",
            method: "PUT",
            operationId: "updatePriceEligibility_1",
            summary: null,
            methodName: `billToPartyPriceEligibility_put_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$f220b616e5373a22 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/bill/estimate`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/bill/estimate",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `billEstimate_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 409:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$9207949e817e53ec = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/billing-admins`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/billing-admins",
            method: "GET",
            operationId: "getBillingAdmins",
            summary: null,
            methodName: `billingAdmins_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$28ff54fcd6634633 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/catalog-accounts/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/catalog-accounts/${key}",
            method: "GET",
            operationId: null,
            summary: "Get catalog account by key ",
            methodName: `catalogAccounts_get_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$6f0cbd795b3f4c22 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/credit-notes`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/credit-notes",
            method: "POST",
            operationId: "createCreditNote",
            summary: null,
            methodName: `creditNotes_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 409:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$4c3d84986ce109bb = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/credit-notes/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/credit-notes/${id}",
            method: "GET",
            operationId: "getCreditNote",
            summary: null,
            methodName: `creditNotes_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$560c8c0c56a50a99 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/credit-notes/${pathParameters.id}/paid`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/credit-notes/${id}/paid",
            method: "POST",
            operationId: "markCreditNotePaid",
            summary: null,
            methodName: `creditNotesPaid_post_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$32b7e02bd2b3f200 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/customer-balance`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/customer-balance",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `customerBalance_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$41bbcaccf7d9d833 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/customer-balance/transactions`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/customer-balance/transactions",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `customerBalanceTransactions_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$9f590651a75a54fa = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/entitlement-templates`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlement-templates",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `entitlementTemplates_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$c3f0f78e974099f7 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/entitlement-templates/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlement-templates/${key}",
            method: "DELETE",
            operationId: null,
            summary: null,
            methodName: `entitlementTemplates_delete_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 204:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$93cd7e743e8afd55 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/entitlement-templates/${pathParameters.key}`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlement-templates/${key}",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `entitlementTemplates_get_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$c0cbaebde0bf045c = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/entitlement-templates/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlement-templates/${key}",
            method: "PUT",
            operationId: null,
            summary: null,
            methodName: `entitlementTemplates_put_byKey_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$fba042b922d41b18 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/entitlement-templates/${pathParameters.key}/history`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlement-templates/${key}/history",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `entitlementTemplatesHistory_get_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$83bb93d01b82295 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/entitlement/${pathParameters.id}/transitions`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlement/${id}/transitions",
            method: "GET",
            operationId: null,
            summary: "Get Entitlement transitions by entitlement ID",
            methodName: `entitlementTransitions_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$c6ad8b5a65449546 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/entitlements/relationships/traverse`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlements/relationships/traverse",
            method: "POST",
            operationId: null,
            summary: "Traverse through entitlements with relationships",
            methodName: `entitlementsRelationshipsTraverse_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$7312e1559e14d346 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/entitlements/slug/validate`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlements/slug/validate",
            method: "GET",
            operationId: null,
            summary: "Validate the Entitlement Slug",
            methodName: `entitlementsSlugValidate_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$ba27cb766e1bfac4 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/entitlements/${pathParameters.entitlementId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlements/${entitlementId}",
            method: "GET",
            operationId: null,
            summary: "Get an entitlement by ID",
            methodName: `entitlements_get_byEntitlementId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$edfc09bacc4cb459 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/entitlements/${pathParameters.entitlementId}/children`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlements/${entitlementId}/children",
            method: "GET",
            operationId: null,
            summary: "Get children of an entitlement by its ID. This API is eventually consistent, please re-try if you do not see all the children attached to an entitlement.",
            methodName: `entitlementsChildren_get_byEntitlementId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$5f0bdd817b9edeb1 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/entitlements/${pathParameters.entitlementId}/details`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/entitlements/${entitlementId}/details",
            method: "GET",
            operationId: "getEntitlementDetails",
            summary: "Get details of an entitlement",
            methodName: `entitlementsDetails_get_byEntitlementId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 401:
                case 500:
                case 503:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 400:
                case 404:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$cd5c74a0786bb5cb = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoice-groups`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups",
            method: "GET",
            operationId: "getInvoiceGroups",
            summary: null,
            methodName: `invoiceGroups_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$12fe7372e856ac7f = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoice-groups`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups",
            method: "POST",
            operationId: "createInvoiceGroup",
            summary: null,
            methodName: `invoiceGroups_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$d17766b9d233e4a7 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoice-groups/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups/${id}",
            method: "GET",
            operationId: "getInvoiceGroup",
            summary: null,
            methodName: `invoiceGroups_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$273485772505c297 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoice-groups/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups/${id}",
            method: "PATCH",
            operationId: "updateInvoiceGroup_1",
            summary: null,
            methodName: `invoiceGroups_patch_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PATCH",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$ede4e00d1d488aaa = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoice-groups/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups/${id}",
            method: "PUT",
            operationId: "updateInvoiceGroup",
            summary: null,
            methodName: `invoiceGroups_put_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$d59cf5490ac7d72e = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoice-groups/${pathParameters.id}/effective-payment-method`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups/${id}/effective-payment-method",
            method: "GET",
            operationId: "getEffectivePaymentMethod",
            summary: null,
            methodName: `invoiceGroupsEffectivePaymentMethod_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$b6375d32b727cbd9 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoice-groups/${pathParameters.id}/effective-price-eligibility`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups/${id}/effective-price-eligibility",
            method: "GET",
            operationId: "getEffectivePriceEligibility",
            summary: null,
            methodName: `invoiceGroupsEffectivePriceEligibility_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$7f5d899ffc9e9188 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoice-groups/${pathParameters.id}/estimate-tax`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups/${id}/estimate-tax",
            method: "POST",
            operationId: "getTaxEstimate",
            summary: null,
            methodName: `invoiceGroupsEstimateTax_post_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$5192f542472b60a0 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoice-groups/${pathParameters.id}/pending-invoice-requests`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups/${id}/pending-invoice-requests",
            method: "GET",
            operationId: "getPendingInvoiceRequests",
            summary: null,
            methodName: `invoiceGroupsPendingInvoiceRequests_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$b627241f39a533b5 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoice-groups/${pathParameters.id}/recipients`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups/${id}/recipients",
            method: "GET",
            operationId: "getRecipients",
            summary: null,
            methodName: `invoiceGroupsRecipients_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$b89c6904d2549942 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoice-groups/${pathParameters.id}/recipients`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups/${id}/recipients",
            method: "PUT",
            operationId: "setAllRecipients",
            summary: null,
            methodName: `invoiceGroupsRecipients_put_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$50b50a8d3882f5c3 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoice-groups/${pathParameters.id}/status`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-groups/${id}/status",
            method: "GET",
            operationId: "getStatus_1",
            summary: null,
            methodName: `invoiceGroupsStatus_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$3a758f813c4a06ce = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoice-requests`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-requests",
            method: "GET",
            operationId: "getInvoiceRequests",
            summary: null,
            methodName: `invoiceRequests_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$8613fc1e2daa9fda = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoice-requests`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoice-requests",
            method: "POST",
            operationId: "createInvoiceRequest",
            summary: null,
            methodName: `invoiceRequests_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 409:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$43f63eef41caee2f = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoices`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices",
            method: "GET",
            operationId: "getInvoices",
            summary: null,
            methodName: `invoices_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$714eb84561444e43 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoices`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices",
            method: "POST",
            operationId: "createAdhocInvoice",
            summary: null,
            methodName: `invoices_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 202:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$c9d893295560f19a = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoices/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices/${id}",
            method: "GET",
            operationId: "getInvoice",
            summary: null,
            methodName: `invoices_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$54c2c265e6083cc1 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoices/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices/${id}",
            method: "PATCH",
            operationId: "updateInvoice",
            summary: null,
            methodName: `invoices_patch_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PATCH",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$fafec8edb8fe6f8c = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoices/${pathParameters.id}/confirm-payment`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices/${id}/confirm-payment",
            method: "POST",
            operationId: "confirmPayment",
            summary: null,
            methodName: `invoicesConfirmPayment_post_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 409:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$b36c6f0f47001e = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoices/${pathParameters.id}/mark-uncollectible`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices/${id}/mark-uncollectible",
            method: "POST",
            operationId: "markInvoiceUncollectible",
            summary: null,
            methodName: `invoicesMarkUncollectible_post_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 404:
                case 409:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 202:
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$aadc4cb21160dca6 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoices/${pathParameters.id}/pay`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices/${id}/pay",
            method: "POST",
            operationId: "attemptToPay",
            summary: null,
            methodName: `invoicesPay_post_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 402:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$e7e1e6ac70617c2c = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoices/${pathParameters.id}/payment-deferred`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices/${id}/payment-deferred",
            method: "POST",
            operationId: "markPaymentDeferred",
            summary: null,
            methodName: `invoicesPaymentDeferred_post_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 402:
                case 404:
                case 409:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$cabe6892ecd1314e = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoices/${pathParameters.id}/record-dunning`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices/${id}/record-dunning",
            method: "POST",
            operationId: "recordDunningAttemptPushPayment",
            summary: null,
            methodName: `invoicesRecordDunning_post_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 409:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$1d50003a317943a2 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoices/${pathParameters.id}/resend-email`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices/${id}/resend-email",
            method: "POST",
            operationId: "sendEmail",
            summary: null,
            methodName: `invoicesResendEmail_post_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$2d45d57dcde79fbe = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoices/${pathParameters.id}/user-defined-note`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices/${id}/user-defined-note",
            method: "POST",
            operationId: "addUserDefinedNote",
            summary: null,
            methodName: `invoicesUserDefinedNote_post_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$da1c3b49cbbcedc4 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/invoices/${pathParameters.invoiceId}/download`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/invoices/${invoiceId}/download",
            method: "GET",
            operationId: "getInvoice",
            summary: "Download an invoice",
            methodName: `invoicesDownload_get_byInvoiceId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 401:
                case 500:
                case 503:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 400:
                case 404:
                    return (0, $d5s5i.success)(null);
                case 200:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$MIME_TYPE_NOT_SUPPORTED
                    });
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$5edc14752400fba9 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/migrations/payment-methods`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/migrations/payment-methods",
            method: "POST",
            operationId: "createPaymentMethod_1",
            summary: null,
            methodName: `migrationsPaymentMethods_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 202:
                case 400:
                case 404:
                case 409:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$c84e4b20160080da = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/migrations/transaction-account/event`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/migrations/transaction-account/event",
            method: "GET",
            operationId: "getTransactionAccountEvent",
            summary: null,
            methodName: `migrationsTransactionAccountEvent_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$2f62cd30845b329a = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offering-by-slug/${pathParameters.slug}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-by-slug/${slug}",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringBySlug_get_bySlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$977150cd36cd52ce = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offering-changes`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-changes",
            method: "POST",
            operationId: null,
            summary: "Create offering change",
            methodName: `offeringChanges_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$aac538cf0e3dcdb3 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offering-changes/${pathParameters.offeringChangeId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-changes/${offeringChangeId}",
            method: "DELETE",
            operationId: null,
            summary: "Delete offering change by offeringChangeId",
            methodName: `offeringChanges_delete_byOfferingChangeId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 204:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$32cb440ba5734c7a = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offering-changes/${pathParameters.offeringChangeId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-changes/${offeringChangeId}",
            method: "GET",
            operationId: null,
            summary: "Get offering change by offeringChangeId",
            methodName: `offeringChanges_get_byOfferingChangeId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$75c2e731611782fc = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offering-changes/${pathParameters.offeringChangeId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-changes/${offeringChangeId}",
            method: "PUT",
            operationId: null,
            summary: "Update offering change by offeringChangeId",
            methodName: `offeringChanges_put_byOfferingChangeId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$175c7ff1b369b392 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offering-changes/${pathParameters.offeringChangeId}/migrations`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-changes/${offeringChangeId}/migrations",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringChangesMigrations_get_byOfferingChangeId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$1b29619b910b6b21 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offering-relationship-templates`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-relationship-templates",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringRelationshipTemplates_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$4c8fb76cc8610172 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offering-relationship-templates/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-relationship-templates/${key}",
            method: "GET",
            operationId: null,
            summary: "Get offering relationship template by key ",
            methodName: `offeringRelationshipTemplates_get_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$4111243ff1874a40 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offering-relationship-templates/${pathParameters.key}/status/activate`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-relationship-templates/${key}/status/activate",
            method: "PUT",
            operationId: null,
            summary: null,
            methodName: `offeringRelationshipTemplatesStatusActivate_put_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$a59a7a1dc8423245 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offering-relationships`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-relationships",
            method: "GET",
            operationId: null,
            summary: "Get offering relationships by offeringKey, type and/or mode",
            methodName: `offeringRelationships_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$1543bcdf681968cc = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offering-relationships/bulk-fetch`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-relationships/bulk-fetch",
            method: "GET",
            operationId: null,
            summary: "Get all offering Relationships",
            methodName: `offeringRelationshipsBulkFetch_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$873c2dc19179637e = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offering-relationships/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-relationships/${key}",
            method: "GET",
            operationId: null,
            summary: "Get offering relationship  by key",
            methodName: `offeringRelationships_get_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$ef31f1b7f2ef1125 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offering-relationships/${pathParameters.offeringKey}/meaningful`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offering-relationships/${offeringKey}/meaningful",
            method: "GET",
            operationId: null,
            summary: "Get offering relationship by offering key and set of comma separated related keys ",
            methodName: `offeringRelationshipsMeaningful_get_byOfferingKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$ccca32cb9241996c = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offerings_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$b0596969893f348f = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offerings_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$3514f49eb9d71722 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/fetch-batch`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/fetch-batch",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringsFetchBatch_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$5a1b751e8bcfdd45 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${entityKey}/extensions/${revisionKey}",
            method: "DELETE",
            operationId: null,
            summary: "Delete extension",
            methodName: `offeringsExtensions_delete_byEntityKeyAndRevisionKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 204:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$784db9bfd975b3b2 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${entityKey}/extensions/${revisionKey}",
            method: "GET",
            operationId: null,
            summary: "Get extension",
            methodName: `offeringsExtensions_get_byEntityKeyAndRevisionKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$e82a266ac9b28a7b = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${entityKey}/extensions/${revisionKey}",
            method: "PUT",
            operationId: null,
            summary: "Create/Update extensions",
            methodName: `offeringsExtensions_put_byEntityKeyAndRevisionKey_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$579a46f5e1e37c4c = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSLug}/latest-entitlement-template`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSLug}/latest-entitlement-template",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringsLatestEntitlementTemplate_get_byKeyOrSLug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$4d376cbeb0d99559 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}",
            method: "DELETE",
            operationId: null,
            summary: null,
            methodName: `offerings_delete_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 204:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$c1282b9030b0d9cb = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offerings_get_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$de5d35cbcfbf0b29 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}",
            method: "PATCH",
            operationId: null,
            summary: null,
            methodName: `offerings_patch_byKeyOrSlug_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PATCH",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$17c6280640325cf8 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}",
            method: "PUT",
            operationId: null,
            summary: null,
            methodName: `offerings_put_byKeyOrSlug_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$d6cbf1681f793779 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/activation`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/activation",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringsActivation_post_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$83c9a95731c3aeba = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/children`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/children",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringsChildren_get_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$db06db2ec0c81341 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/depends-on-offerings`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/depends-on-offerings",
            method: "DELETE",
            operationId: null,
            summary: null,
            methodName: `offeringsDependsOnOfferings_delete_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 204:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$7832c2f84436957 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/depends-on-offerings`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/depends-on-offerings",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringsDependsOnOfferings_post_byKeyOrSlug_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$f5d607984e3bcf28 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/depends-on-offerings`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/depends-on-offerings",
            method: "PUT",
            operationId: null,
            summary: null,
            methodName: `offeringsDependsOnOfferings_put_byKeyOrSlug_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$e5807df3d4f67c38 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/depends-on-offerings/${pathParameters.dependsOnKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/depends-on-offerings/${dependsOnKey}",
            method: "DELETE",
            operationId: null,
            summary: null,
            methodName: `offeringsDependsOnOfferings_delete_byKeyOrSlugAndDependsOnKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 204:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$d248131e57253ed1 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/entitlement-templates`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/entitlement-templates",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringsEntitlementTemplates_post_byKeyOrSlug_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$c20df0da7a1740ee = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/pricing-changes`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/pricing-changes",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringsPricingChanges_get_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$ba12661cd7c4eec8 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/pricing-plan-transitions`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/pricing-plan-transitions",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringsPricingPlanTransitions_get_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$8203c67cac5cd588 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/pricing-plans`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/pricing-plans",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringsPricingPlans_get_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$604113c42a8a2638 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/slugs`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/slugs",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringsSlugs_post_byKeyOrSlug_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$fef1dd260076e1fb = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/synthetics`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/synthetics",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringsSynthetics_get_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$deb9ee0b7e7aca11 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/synthetics`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/synthetics",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringsSynthetics_post_byKeyOrSlug_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$4bfb6fe963934e2d = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/synthetics/${pathParameters.templateType}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/synthetics/${templateType}",
            method: "DELETE",
            operationId: null,
            summary: null,
            methodName: `offeringsSynthetics_delete_byKeyOrSlugAndTemplateType_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 200:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$e9b470f1c36ac062 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/synthetics/${pathParameters.templateType}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/synthetics/${templateType}",
            method: "PUT",
            operationId: null,
            summary: null,
            methodName: `offeringsSynthetics_put_byKeyOrSlugAndTemplateType_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$62b78cb04625261c = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/synthetics/${pathParameters.type}/generate`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/synthetics/${type}/generate",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringsSyntheticsGenerate_post_byKeyOrSlugAndType_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$51cba03e482daaaf = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/transitions`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/transitions",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringsTransitions_get_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$dc8168e4eb6f3010 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/trial`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/trial",
            method: "DELETE",
            operationId: null,
            summary: null,
            methodName: `offeringsTrial_delete_byKeyOrSlug_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 200:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$2f4131ab4e1d7a8e = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/offerings/${pathParameters.keyOrSlug}/trial`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/offerings/${keyOrSlug}/trial",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringsTrial_post_byKeyOrSlug_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$4a001194c1527f6b = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/order-defaults/${pathParameters.offeringId}`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/order-defaults/${offeringId}",
            method: "GET",
            operationId: "getOrderDefault",
            summary: "Get order default",
            methodName: `orderDefaults_get_byOfferingId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 412:
                case 500:
                case 503:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$cd66f06369cd63cf = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/orderIntent`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/orderIntent",
            method: "POST",
            operationId: null,
            summary: "Create Order Intent",
            methodName: `orderIntent_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$c35af7866b12b1af = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/orderIntent/estimate`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/orderIntent/estimate",
            method: "POST",
            operationId: null,
            summary: "Get Bill Estimate for Order",
            methodName: `orderIntentEstimate_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$ce7a87dd3cb8b7b8 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/orderIntent/preview`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/orderIntent/preview",
            method: "POST",
            operationId: null,
            summary: "Preview Order",
            methodName: `orderIntentPreview_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$b84fa7efc0407766 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/orderIntent/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/orderIntent/${id}",
            method: "GET",
            operationId: null,
            summary: "Get order intent by id",
            methodName: `orderIntent_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$a111b175e51c818d = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/orderIntent/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/orderIntent/${id}",
            method: "PATCH",
            operationId: null,
            summary: "Update status of order intent by id",
            methodName: `orderIntent_patch_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PATCH",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 200:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$5e9650246ea130d = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/orderItem/${pathParameters.orderItemId}/rewindToDetails`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/orderItem/${orderItemId}/rewindToDetails",
            method: "GET",
            operationId: null,
            summary: "Get RewindToDetails From OrderItemId",
            methodName: `orderItemRewindToDetails_get_byOrderItemId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$78301b217fb99316 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/orderItems`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/orderItems",
            method: "GET",
            operationId: null,
            summary: "Get order by entitlement id",
            methodName: `orderItems_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$3b9d6eeb7d030d96 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/orders`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/orders",
            method: "POST",
            operationId: null,
            summary: "Create order",
            methodName: `orders_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$4412f9c3ddfc1f12 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/orders/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/orders/${id}",
            method: "GET",
            operationId: null,
            summary: "Get order by id",
            methodName: `orders_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$1c0e11b1c2be4f09 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/orders/${pathParameters.orderId}/orderItem/${pathParameters.orderItemId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/orders/${orderId}/orderItem/${orderItemId}",
            method: "GET",
            operationId: null,
            summary: "Get order by order item id",
            methodName: `ordersOrderItem_get_byOrderIdAndOrderItemId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 404:
                case 405:
                case 409:
                case 415:
                case 422:
                case 423:
                case 500:
                case 501:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$b61cd22bcdefca48 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/partner-acquisitions/entitlements/${pathParameters.entitlementId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/partner-acquisitions/entitlements/${entitlementId}",
            method: "GET",
            operationId: "getEntitlementSummary",
            summary: "Get summary of an entitlement for partners",
            methodName: `partnerAcquisitionsEntitlements_get_byEntitlementId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 401:
                case 500:
                case 503:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 400:
                case 404:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$b6294bcb6452472d = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/partner-status`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/partner-status",
            method: "GET",
            operationId: "getPartnerStatus",
            summary: null,
            methodName: `partnerStatus_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$8754bb4d180f1b03 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/payment-methods`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/payment-methods",
            method: "GET",
            operationId: "getPaymentMethods",
            summary: null,
            methodName: `paymentMethods_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$7d2defaa4dff104e = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/payment-methods`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/payment-methods",
            method: "POST",
            operationId: "createPaymentMethod",
            summary: null,
            methodName: `paymentMethods_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$cd3edf7e3b063725 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/payment-methods/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/payment-methods/${id}",
            method: "DELETE",
            operationId: "deletePaymentMethod",
            summary: null,
            methodName: `paymentMethods_delete_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 204:
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$2bebd0d8b3fab52a = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/payment-methods/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/payment-methods/${id}",
            method: "GET",
            operationId: "getPaymentMethod",
            summary: null,
            methodName: `paymentMethods_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$dc1e4d0137613f87 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/payment-methods/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/payment-methods/${id}",
            method: "PATCH",
            operationId: "updateDeferredPaymentMethod",
            summary: null,
            methodName: `paymentMethods_patch_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PATCH",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$7a4975126fecfbef = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/payment-methods/${pathParameters.id}/delete`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/payment-methods/${id}/delete",
            method: "POST",
            operationId: "deletePaymentMethodV2",
            summary: null,
            methodName: `paymentMethodsDelete_post_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 204:
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$38239369451605f0 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/payment-methods/${pathParameters.id}/set-default`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/payment-methods/${id}/set-default",
            method: "PUT",
            operationId: "setDefault",
            summary: null,
            methodName: `paymentMethodsSetDefault_put_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$69411303ef646976 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/pricing-changes`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-changes",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `pricingChanges_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$fec2c6189c2cc272 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/pricing-changes/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-changes/${id}",
            method: "PUT",
            operationId: null,
            summary: null,
            methodName: `pricingChanges_put_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$5f4e44f2e37ee88a = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/pricing-changes/${pathParameters.pricingChangeId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-changes/${pricingChangeId}",
            method: "DELETE",
            operationId: null,
            summary: null,
            methodName: `pricingChanges_delete_byPricingChangeId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 204:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$67236cecf4989e8f = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/pricing-changes/${pathParameters.pricingChangeId}/migrations`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-changes/${pricingChangeId}/migrations",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `pricingChangesMigrations_get_byPricingChangeId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$49a75b9033421fce = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/pricing-plans`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `pricingPlans_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$bbf988401d0542fe = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/pricing-plans`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `pricingPlans_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$de1a4f824d8c5d4f = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/pricing-plans/event`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans/event",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `pricingPlansEvent_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$cfb577a37b681cd5 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/pricing-plans/fetch-batch`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans/fetch-batch",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `pricingPlansFetchBatch_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$4a543453e9124c17 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/pricing-plans/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans/${entityKey}/extensions/${revisionKey}",
            method: "DELETE",
            operationId: null,
            summary: "Delete extension",
            methodName: `pricingPlansExtensions_delete_byEntityKeyAndRevisionKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 204:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$b2ffe6a4625f3e5a = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/pricing-plans/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans/${entityKey}/extensions/${revisionKey}",
            method: "GET",
            operationId: null,
            summary: "Get extension",
            methodName: `pricingPlansExtensions_get_byEntityKeyAndRevisionKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$1435710623655598 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/pricing-plans/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans/${entityKey}/extensions/${revisionKey}",
            method: "PUT",
            operationId: null,
            summary: "Create/Update extensions",
            methodName: `pricingPlansExtensions_put_byEntityKeyAndRevisionKey_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$30c5db285cef99c2 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/pricing-plans/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans/${key}",
            method: "DELETE",
            operationId: null,
            summary: null,
            methodName: `pricingPlans_delete_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 204:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$a2c2134cad391600 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/pricing-plans/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans/${key}",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `pricingPlans_get_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$d4eda58409c2a5f3 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/pricing-plans/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans/${key}",
            method: "PUT",
            operationId: null,
            summary: null,
            methodName: `pricingPlans_put_byKey_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$b73bd73e7153ed2c = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/pricing-plans/${pathParameters.key}/transitions`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/pricing-plans/${key}/transitions",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `pricingPlansTransitions_get_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$4ee3bc885afe9cd2 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/product-ignore-rule/${pathParameters.productKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/product-ignore-rule/${productKey}",
            method: "DELETE",
            operationId: null,
            summary: "Delete product ignore rule by product key",
            methodName: `productIgnoreRule_delete_byProductKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 204:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$8b5cf78f8d4822a = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/product-ignore-rule/${pathParameters.productKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/product-ignore-rule/${productKey}",
            method: "GET",
            operationId: null,
            summary: "Get product ignore rule by product key",
            methodName: `productIgnoreRule_get_byProductKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$da81cfb110e24504 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/product-ignore-rule/${pathParameters.productKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/product-ignore-rule/${productKey}",
            method: "POST",
            operationId: null,
            summary: "Create new product ignore rule",
            methodName: `productIgnoreRule_post_byProductKey_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$d0f8604ef8fb016c = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/product-ignore-rule/${pathParameters.productKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/product-ignore-rule/${productKey}",
            method: "PUT",
            operationId: null,
            summary: "Update existing product ignore rule",
            methodName: `productIgnoreRule_put_byProductKey_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 204:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$858c6a9779df7b0c = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/products`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `products_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$1a9d49af5faa5607 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/products`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `products_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$eb4b1bdf7b6d1330 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/products/event`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/event",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `productsEvent_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$998ae45f4ab47ae5 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/products/fetch-batch`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/fetch-batch",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `productsFetchBatch_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$c7060835ec030854 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/products/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${entityKey}/extensions/${revisionKey}",
            method: "DELETE",
            operationId: null,
            summary: "Delete extension",
            methodName: `productsExtensions_delete_byEntityKeyAndRevisionKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 204:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$367e9592db7d46da = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/products/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${entityKey}/extensions/${revisionKey}",
            method: "GET",
            operationId: null,
            summary: "Get extension",
            methodName: `productsExtensions_get_byEntityKeyAndRevisionKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$7f704cc93413d3af = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/products/${pathParameters.entityKey}/extensions/${pathParameters.revisionKey}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${entityKey}/extensions/${revisionKey}",
            method: "PUT",
            operationId: null,
            summary: "Create/Update extensions",
            methodName: `productsExtensions_put_byEntityKeyAndRevisionKey_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$462b4802870c16de = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/products/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${key}",
            method: "DELETE",
            operationId: null,
            summary: null,
            methodName: `products_delete_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "DELETE",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 204:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$3bcf0dd6b7a90147 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/products/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${key}",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `products_get_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$8acdde07553cc857 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/products/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${key}",
            method: "PATCH",
            operationId: null,
            summary: null,
            methodName: `products_patch_byKey_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PATCH",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$7ab20f0f53a0a7e9 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/products/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${key}",
            method: "PUT",
            operationId: null,
            summary: null,
            methodName: `products_put_byKey_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$5983aa44b9b9d33c = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/products/${pathParameters.key}/offering-changes`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${key}/offering-changes",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `productsOfferingChanges_get_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$8e4c31a99f2a3e6c = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/products/${pathParameters.key}/status/active`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${key}/status/active",
            method: "PUT",
            operationId: null,
            summary: null,
            methodName: `productsStatusActive_put_byKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 204:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$c25290c2f592e275 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/products/${pathParameters.productId}/entitlement-templates`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${productId}/entitlement-templates",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `productsEntitlementTemplates_get_byProductId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$6834600abc16ae45 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/products/${pathParameters.productKey}/offering-groups`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${productKey}/offering-groups",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `productsOfferingGroups_get_byProductKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$62dc9fec3c836eff = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/products/${pathParameters.productKey}/offerings`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/products/${productKey}/offerings",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `productsOfferings_get_byProductKey_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$ec91a4fe56de5d51 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/promotion-codes/applicable`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotion-codes/applicable",
            method: "POST",
            operationId: null,
            summary: "Verifies the applicability of the promotion codes",
            methodName: `promotionCodesApplicable_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$63948248a3ed19a1 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/promotion-codes/exhausted`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotion-codes/exhausted",
            method: "POST",
            operationId: null,
            summary: "Verifies the promotion codes has already been used",
            methodName: `promotionCodesExhausted_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$62a939642e00b9d8 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/promotions/available`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/available",
            method: "POST",
            operationId: "getAvailablePromotion",
            summary: "Returns all promotion, satisfying promotion rules",
            methodName: `promotionsAvailable_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$dea95cb86eebef9c = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/promotions/event/${pathParameters.promotionId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/event/${promotionId}",
            method: "PUT",
            operationId: "updatePromotionStatusEvent",
            summary: "Update promotion status",
            methodName: `promotionsEvent_put_byPromotionId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 204:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$98768e3f40c0cfdb = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/promotions/redemptions`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/redemptions",
            method: "GET",
            operationId: "getPaginatedRedemptions",
            summary: "Get paginated redemptions",
            methodName: `promotionsRedemptions_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$96ea62595122da2f = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/promotions/${pathParameters.promotionId}/promotion-codes`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/${promotionId}/promotion-codes",
            method: "GET",
            operationId: "getPromotionCodesByPromotionIdAndStatus",
            summary: "Get all promotion codes by promotion id and status",
            methodName: `promotionsPromotionCodes_get_byPromotionId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$523784976dad86af = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/promotions/${pathParameters.promotionId}/promotion-codes`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/${promotionId}/promotion-codes",
            method: "POST",
            operationId: "createPromotionCode",
            summary: "Create new promotion codes",
            methodName: `promotionsPromotionCodes_post_byPromotionId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$bf703926b07e9f11 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/promotions/${pathParameters.promotionId}/promotion-codes/${pathParameters.promotionCode}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/${promotionId}/promotion-codes/${promotionCode}",
            method: "GET",
            operationId: "getPromotionCode",
            summary: "Get promotion code by promotion id and code",
            methodName: `promotionsPromotionCodes_get_byPromotionIdAndPromotionCode_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$4662a6074db86be8 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/promotions/${pathParameters.promotionId}/promotion-codes/${pathParameters.promotionCode}/event/${pathParameters.event}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/${promotionId}/promotion-codes/${promotionCode}/event/${event}",
            method: "PUT",
            operationId: "updatePromotionStatus_1",
            summary: "Update promotion code status",
            methodName: `promotionsPromotionCodesEvent_put_byPromotionIdAndPromotionCodeAndEvent_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 204:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$6e1c8bd110ba18ab = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/promotions/${pathParameters.promotionId}/promotion-codes/${pathParameters.promotionCode}/redemption`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/${promotionId}/promotion-codes/${promotionCode}/redemption",
            method: "PUT",
            operationId: "redeemPromoCode_1",
            summary: "Update Redemption For valid Promo Code",
            methodName: `promotionsPromotionCodesRedemption_put_byPromotionIdAndPromotionCode_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$19bf421d174c60ee = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/promotions/${pathParameters.promotionId}/promotion-codes/${pathParameters.promotionCode}/redemptions`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/${promotionId}/promotion-codes/${promotionCode}/redemptions",
            method: "GET",
            operationId: "getAllRedemptionsByPromotionIdAndPromotionCode",
            summary: "Get redemptions by promotion code",
            methodName: `promotionsPromotionCodesRedemptions_get_byPromotionIdAndPromotionCode_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$7282157f5c1b905b = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/promotions/${pathParameters.promotionId}/randomised-promotion-codes`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/${promotionId}/randomised-promotion-codes",
            method: "POST",
            operationId: "createRandom",
            summary: "Create new randomised promotion codes",
            methodName: `promotionsRandomisedPromotionCodes_post_byPromotionId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$f841b45d7999eb46 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/promotions/${pathParameters.promotionId}/${pathParameters.event}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/promotions/${promotionId}/${event}",
            method: "PUT",
            operationId: "updatePromotionStatus",
            summary: "Update promotion status",
            methodName: `promotions_put_byPromotionIdAndEvent_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 204:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$77859df048f21f33 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/quotes`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes",
            method: "POST",
            operationId: null,
            summary: "Create draft quote",
            methodName: `quotes_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$4142abd422c6a87a = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/quotes/open`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/open",
            method: "POST",
            operationId: null,
            summary: "Create new open quote",
            methodName: `quotesOpen_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$427baae892994f3f = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}",
            method: "GET",
            operationId: null,
            summary: "Get quote",
            methodName: `quotes_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$b5c39ab604a396f = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}",
            method: "PATCH",
            operationId: null,
            summary: "Update an open quote",
            methodName: `quotes_patch_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PATCH",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$37b5ddadc6bf9219 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}",
            method: "PUT",
            operationId: null,
            summary: "Update an existing quote",
            methodName: `quotes_put_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$d48674411fa7c111 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}/cancel`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}/cancel",
            method: "POST",
            operationId: null,
            summary: "Cancel a quote",
            methodName: `quotesCancel_post_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$ee0a95f68903e5ac = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}/clone`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}/clone",
            method: "POST",
            operationId: null,
            summary: "Clone a new quote from a given quote",
            methodName: `quotesClone_post_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$2d893a8f61257586 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}/download`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}/download",
            method: "GET",
            operationId: null,
            summary: "Download quote",
            methodName: `quotesDownload_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 200:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$MIME_TYPE_NOT_SUPPORTED
                    });
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$d459665743fd49c3 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}/draft`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}/draft",
            method: "POST",
            operationId: null,
            summary: "Move stale quote to draft",
            methodName: `quotesDraft_post_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$fe62e4c16e2bc31c = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}/finalize`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}/finalize",
            method: "POST",
            operationId: null,
            summary: "Finalize a quote",
            methodName: `quotesFinalize_post_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$f590e474b09e604e = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}/reestimate`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}/reestimate",
            method: "POST",
            operationId: null,
            summary: "Re-estimate a quote",
            methodName: `quotesReestimate_post_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 202:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$b729d81f10afda7c = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}/revise`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}/revise",
            method: "POST",
            operationId: null,
            summary: "Create new revision of a quote",
            methodName: `quotesRevise_post_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$4906099f27fab3d2 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/quotes/${pathParameters.id}/version/${pathParameters.version}/accept`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/quotes/${id}/version/${version}/accept",
            method: "POST",
            operationId: null,
            summary: "Accept a quote",
            methodName: `quotesVersionAccept_post_byIdAndVersion_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 403:
                case 404:
                case 405:
                case 409:
                case 415:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$ef9e25a85bc0acfb = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/roles/assignments/create`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/roles/assignments/create",
            method: "POST",
            operationId: "addRoleAssignment",
            summary: null,
            methodName: `rolesAssignmentsCreate_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$bb02dedc68cc730e = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/roles/assignments/create/bulk`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/roles/assignments/create/bulk",
            method: "POST",
            operationId: "addBulkRoleAssignments",
            summary: null,
            methodName: `rolesAssignmentsCreateBulk_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 202:
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$28c3c666c914a67e = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/roles/assignments/delete`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/roles/assignments/delete",
            method: "POST",
            operationId: "deleteRoleAssignment",
            summary: null,
            methodName: `rolesAssignmentsDelete_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 204:
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$1fbeb8957df41f86 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/roles/assignments/principals`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/roles/assignments/principals",
            method: "GET",
            operationId: "queryPrincipals",
            summary: null,
            methodName: `rolesAssignmentsPrincipals_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$25f3475dfe736e33 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/routes`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/routes",
            method: "POST",
            operationId: null,
            summary: "Get route for promotion",
            methodName: `routes_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$eb04a65b0a9e9f54 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/search`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/search",
            method: "POST",
            operationId: null,
            summary: "Provides search capabilities for different ccp primitives",
            methodName: `search_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 400:
                case 404:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$4bf83929e86ba835 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/search/count`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/search/count",
            method: "POST",
            operationId: null,
            summary: "Provides count for different ccp primitives",
            methodName: `searchCount_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 400:
                case 404:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$847ab50bf477bbe8 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/search/public-search`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/search/public-search",
            method: "POST",
            operationId: null,
            summary: "Provides search capabilities for public ccp primitives",
            methodName: `searchPublicSearch_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 400:
                case 404:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$fdeb33d0bad52579 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/setup-intents`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/setup-intents",
            method: "POST",
            operationId: "createSetUpIntent",
            summary: null,
            methodName: `setupIntents_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$ec8b46b98d8656e4 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/ship-to-parties`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/ship-to-parties",
            method: "GET",
            operationId: "getAll",
            summary: null,
            methodName: `shipToParties_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$ee6147dbccbd12a8 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/ship-to-parties`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/ship-to-parties",
            method: "POST",
            operationId: "createNew",
            summary: null,
            methodName: `shipToParties_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$bdb1aa3f48765578 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/ship-to-parties/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/ship-to-parties/${id}",
            method: "GET",
            operationId: "get",
            summary: null,
            methodName: `shipToParties_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$be695fff70c368af = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/ship-to-parties/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/ship-to-parties/${id}",
            method: "PUT",
            operationId: "updateAddress",
            summary: null,
            methodName: `shipToParties_put_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$3cd9d779af362e56 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/ship-to-parties/${pathParameters.id}/price-eligibility`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/ship-to-parties/${id}/price-eligibility",
            method: "GET",
            operationId: "getPriceEligibility",
            summary: null,
            methodName: `shipToPartiesPriceEligibility_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$96225d78c7ec6fa0 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/ship-to-parties/${pathParameters.id}/price-eligibility`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/ship-to-parties/${id}/price-eligibility",
            method: "PUT",
            operationId: "updatePriceEligibility",
            summary: null,
            methodName: `shipToPartiesPriceEligibility_put_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$7550184da29bfc5f = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/status`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/status",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `status_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$bbbefa7976cb6a96 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/test/billing-clocks`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/test/billing-clocks",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `testBillingClocks_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 404:
                case 409:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$ecbb714809618dcf = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/test/billing-clocks/${pathParameters.id}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/test/billing-clocks/${id}",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `testBillingClocks_get_byId_v1`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 409:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$83b6c4c183260714 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/test/billing-clocks/${pathParameters.id}/advance`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/test/billing-clocks/${id}/advance",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `testBillingClocksAdvance_post_byId_v1`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 202:
                case 400:
                case 404:
                case 409:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$b389f95f6743518a = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/test/subscription/usage`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/test/subscription/usage",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `testSubscriptionUsage_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 400:
                case 404:
                case 409:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 200:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$c86fe91ccd40c3d2 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", headers: headers, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/transaction-accounts`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/transaction-accounts",
            method: "GET",
            operationId: "getTransactionAccounts",
            summary: null,
            methodName: `transactionAccounts_get_v1`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$cc5d8891fb2996a7 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v1/transaction-accounts`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v1/transaction-accounts",
            method: "POST",
            operationId: "create",
            summary: null,
            methodName: `transactionAccounts_post_v1`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 202:
                case 400:
                case 429:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                case 401:
                case 403:
                    return (0, $d5s5i.success)(null);
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$397fa8292bb60668 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v2/offerings`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/offerings",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offerings_get_v2`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$914bdd382bf4f842 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v2/offerings`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/offerings",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offerings_post_v2`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$ff1bebecb4c4f758 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, headers: headers, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v2/offerings/event`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/offerings/event",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringsEvent_get_v2`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$7c2faa2e7deb25fa = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v2/offerings/fetch-batch`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/offerings/fetch-batch",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringsFetchBatch_post_v2`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$e3af894c788b8060 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v2/offerings/${pathParameters.id}/default-entitlement-template`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/offerings/${id}/default-entitlement-template",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringsDefaultEntitlementTemplate_get_byId_v2`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$28955c9e2ad42a04 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v2/offerings/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/offerings/${key}",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offerings_get_byKey_v2`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$4df5689a1d4857d9 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v2/offerings/${pathParameters.key}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/offerings/${key}",
            method: "PATCH",
            operationId: null,
            summary: null,
            methodName: `offerings_patch_byKey_v2`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PATCH",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$2bea338c3c49b1a1 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v2/offerings/${pathParameters.key}/activation`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/offerings/${key}/activation",
            method: "POST",
            operationId: null,
            summary: null,
            methodName: `offeringsActivation_post_byKey_v2`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$c566a1cb96e67330 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v2/offerings/${pathParameters.offeringKey}/active-pricing-plans-count`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/offerings/${offeringKey}/active-pricing-plans-count",
            method: "GET",
            operationId: null,
            summary: null,
            methodName: `offeringsActivePricingPlansCount_get_byOfferingKey_v2`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 401:
                case 403:
                case 404:
                case 409:
                case 423:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$80a8163873d9040c = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", queryParameters: queryParameters, hooks: hooks } = {})=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v2/promotions`, baseGatewayUrl, queryParameters);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/promotions",
            method: "GET",
            operationId: null,
            summary: "Get paginated promotions",
            methodName: `promotions_get_v2`
        },
        data: {
            body: undefined,
            pathParameters: undefined,
            queryParameters: queryParameters,
            headers: undefined
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text"
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$2b0ddaa223c45fff = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v2/promotions`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/promotions",
            method: "POST",
            operationId: null,
            summary: "Create new promotion",
            methodName: `promotions_post_v2`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 201:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$1a4c42c3dd4c2894 = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v2/promotions/applicable`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/promotions/applicable",
            method: "POST",
            operationId: null,
            summary: "Verifies the applicability of the promotions",
            methodName: `promotionsApplicable_post_v2`
        },
        data: {
            body: body,
            pathParameters: undefined,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "POST",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$f7759eb9d4d2ddaf = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v2/promotions/${pathParameters.promotionId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/promotions/${promotionId}",
            method: "GET",
            operationId: null,
            summary: "Get promotion by id",
            methodName: `promotions_get_byPromotionId_v2`
        },
        data: {
            body: undefined,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "GET",
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 200:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$8a1f2d6ca826beda = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v2/promotions/${pathParameters.promotionId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/promotions/${promotionId}",
            method: "PATCH",
            operationId: null,
            summary: "Patch promotion details",
            methodName: `promotions_patch_byPromotionId_v2`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PATCH",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 204:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
const $7f245dfb02e39f03$export$591e24eef82e873b = $7f245dfb02e39f03$export$231366cf7929fca(async ({ fetch: fetch = globalThis.fetch, baseGatewayUrl: baseGatewayUrl = "/gateway/api/ccp/", body: body, pathParameters: pathParameters, headers: headers, hooks: hooks })=>{
    if (baseGatewayUrl.length === 0 || baseGatewayUrl[baseGatewayUrl.length - 1] !== "/") throw new Error("baseGatewayUrl must end with a slash");
    const url = $7f245dfb02e39f03$export$a639a54e55b70225(`api/v2/promotions/${pathParameters.promotionId}`, baseGatewayUrl);
    const requestHooks = await hooks?.({
        configuration: {
            baseGatewayUrl: baseGatewayUrl
        },
        schema: {
            path: "/api/v2/promotions/${promotionId}",
            method: "PUT",
            operationId: null,
            summary: "Update promotion details",
            methodName: `promotions_put_byPromotionId_v2`
        },
        data: {
            body: body,
            pathParameters: pathParameters,
            queryParameters: undefined,
            headers: headers
        }
    });
    try {
        await requestHooks?.request?.();
        const fetchResponse = await fetch(url, {
            method: "PUT",
            // Note: Stringifying into JSON is currently hard coded. It may not actually be the correct request body content type
            body: JSON.stringify(body),
            headers: {
                // Hard coded to JSON for now
                "Content-Type": "application/json",
                Accept: "application/json, plain/text",
                // Fetch types don't allow interpreted types but runtime allows it, hence the cast
                ...headers
            }
        });
        const sharedFields = {
            response: fetchResponse,
            status: fetchResponse.status
        };
        const bodyResult = await (async ()=>{
            switch(fetchResponse.status){
                case 204:
                case 400:
                case 404:
                case 405:
                case 409:
                case 415:
                case 423:
                case 500:
                    return (0, $d5s5i.success)(await fetchResponse.json());
                default:
                    return (0, $d5s5i.error)({
                        ...sharedFields,
                        code: $7f245dfb02e39f03$var$NOT_IN_SCHEMA
                    });
            }
        })();
        await requestHooks?.response?.((0, $d5s5i.isSuccess)(bodyResult) ? fetchResponse.status >= 200 && fetchResponse.status < 300 ? {
            type: "success",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "failure",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            body: bodyResult.payload,
            response: fetchResponse
        } : {
            type: "invalid",
            status: fetchResponse.status,
            statusText: fetchResponse.statusText,
            code: bodyResult.error.code,
            response: fetchResponse
        });
        if ((0, $d5s5i.isFailure)(bodyResult)) return bodyResult;
        return (0, $d5s5i.success)({
            body: bodyResult.payload,
            ...sharedFields
        });
    } catch (error) {
        const ex = error instanceof Error ? error : new Error(String(error));
        await requestHooks?.error?.({
            exception: ex
        });
        return (0, $d5s5i.exception)(ex);
    }
});
module.exports["getSuccessfulResultOrThrow"] = $7f245dfb02e39f03$export$390f7ebd9b7a4732;
module.exports["entitlementsDetails_get_byEntitlementId_v1"] = $7f245dfb02e39f03$export$5f0bdd817b9edeb1;
module.exports["invoiceGroups_post_v1"] = $7f245dfb02e39f03$export$12fe7372e856ac7f;
module.exports["invoiceGroupsEffectivePaymentMethod_get_byId_v1"] = $7f245dfb02e39f03$export$d59cf5490ac7d72e;
module.exports["invoiceRequests_get_v1"] = $7f245dfb02e39f03$export$3a758f813c4a06ce;
module.exports["orderDefaults_get_byOfferingId_v1"] = $7f245dfb02e39f03$export$4a001194c1527f6b;
module.exports["orders_post_v1"] = $7f245dfb02e39f03$export$3b9d6eeb7d030d96;

});

parcelRegister("d5s5i", function(module, exports) {
"use strict";
const $640a47fa2010f0c0$export$87478ad3f0539058 = 'payload';
const $640a47fa2010f0c0$export$638cc6e36b2a737a = $640a47fa2010f0c0$export$87478ad3f0539058;
const $640a47fa2010f0c0$export$eade6b6091579183 = $640a47fa2010f0c0$export$87478ad3f0539058;
const $640a47fa2010f0c0$export$103bedf43ba882db = 'error';
const $640a47fa2010f0c0$export$e7e66e0bc92d8ea1 = 'exception';


"use strict";
const $61e0bb6f59efd820$export$40f07171f4b6ee01 = (result)=>result.type === $640a47fa2010f0c0$export$e7e66e0bc92d8ea1;
const $61e0bb6f59efd820$export$e6127cc7fe7395c3 = (result)=>result.type === $640a47fa2010f0c0$export$103bedf43ba882db;
const $61e0bb6f59efd820$export$bd63a49166768e99 = (result)=>result.type === $640a47fa2010f0c0$export$638cc6e36b2a737a;
const $61e0bb6f59efd820$export$46dd8fdc8be98d59 = $61e0bb6f59efd820$export$bd63a49166768e99;
const $61e0bb6f59efd820$export$b0ac3e614a309be3 = $61e0bb6f59efd820$export$bd63a49166768e99;
const $61e0bb6f59efd820$export$4ece3b219cb1e8e7 = (result)=>{
    switch(result.type){
        case $640a47fa2010f0c0$export$103bedf43ba882db:
        case $640a47fa2010f0c0$export$e7e66e0bc92d8ea1:
            return true;
        default:
            return false;
    }
};
const $61e0bb6f59efd820$export$5e805c3762185b4c = (payload)=>({
        type: $640a47fa2010f0c0$export$638cc6e36b2a737a,
        payload: payload,
        error: undefined,
        exception: undefined
    });
const $61e0bb6f59efd820$export$fe7c49d056ea1d88 = $61e0bb6f59efd820$export$5e805c3762185b4c;
const $61e0bb6f59efd820$export$411e9a7b4316b872 = $61e0bb6f59efd820$export$5e805c3762185b4c;
const $61e0bb6f59efd820$export$a3bc9b8ed74fc = (error)=>({
        type: $640a47fa2010f0c0$export$103bedf43ba882db,
        payload: undefined,
        error: error,
        exception: undefined
    });
const $61e0bb6f59efd820$export$788a307bb494601 = (exception)=>{
    return {
        type: $640a47fa2010f0c0$export$e7e66e0bc92d8ea1,
        payload: undefined,
        error: undefined,
        exception: exception
    };
};
const $61e0bb6f59efd820$export$aadcd93c949999c0 = (result, handlers = {})=>{
    switch(result.type){
        case $640a47fa2010f0c0$export$638cc6e36b2a737a:
            {
                const { payload: payload } = result;
                if (handlers.payload !== undefined) return handlers.payload(payload, result);
                break;
            }
        case $640a47fa2010f0c0$export$103bedf43ba882db:
            {
                const { error: error } = result;
                if (handlers.error !== undefined) return handlers.error(error, result);
                break;
            }
        case $640a47fa2010f0c0$export$e7e66e0bc92d8ea1:
            {
                const { exception: exception } = result;
                if (handlers.exception !== undefined) return handlers.exception(exception, result);
                break;
            }
    }
    return result;
};
const $61e0bb6f59efd820$export$8f34ce051745d39e = (result, handlers = {})=>{
    try {
        return $61e0bb6f59efd820$export$aadcd93c949999c0(result, handlers);
    } catch (err) {
        return $61e0bb6f59efd820$export$788a307bb494601(err);
    }
};
module.exports["isException"] = $61e0bb6f59efd820$export$40f07171f4b6ee01;
module.exports["isSuccess"] = $61e0bb6f59efd820$export$b0ac3e614a309be3;
module.exports["isFailure"] = $61e0bb6f59efd820$export$4ece3b219cb1e8e7;
module.exports["success"] = $61e0bb6f59efd820$export$fe7c49d056ea1d88;
module.exports["error"] = $61e0bb6f59efd820$export$a3bc9b8ed74fc;
module.exports["exception"] = $61e0bb6f59efd820$export$788a307bb494601;

});


//# sourceMappingURL=GracePeriodBanner.66791589.js.map
